import _regeneratorRuntime from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _classCallCheck from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { ExternalInteractorBase } from "../../../Core/Utils/ExternalInteractorBase";
export var Remover =
/*#__PURE__*/
function (_ExternalInteractorBa) {
  _inherits(Remover, _ExternalInteractorBa);

  function Remover(container) {
    var _this;

    _classCallCheck(this, Remover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Remover).call(this, container));

    _this.handleClickMode = function (mode) {
      if (mode !== "remove") {
        return;
      }

      var container = _this.container;
      var options = container.actualOptions;
      var removeNb = options.interactivity.modes.remove.quantity;
      container.particles.removeQuantity(removeNb);
    };

    return _this;
  }

  _createClass(Remover, [{
    key: "isEnabled",
    value: function isEnabled() {
      return true;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact() {
      return _regeneratorRuntime.async(function interact$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      });
    }
  }]);

  return Remover;
}(ExternalInteractorBase);